var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.item.active === "true"
    ? _c(
        "a",
        { staticClass: "sidecart__slider", attrs: { href: _vm.item.url } },
        [
          _c("div", { staticClass: "sidecart__slider__image-wrapper" }, [
            _c("div", { staticClass: "sidecart__slider__image-container" }, [
              _c("img", {
                staticClass: "sidecart__slider__image",
                attrs: {
                  src: _vm._f("image")(_vm.item.image, "220x"),
                  alt: _vm.item.title,
                },
              }),
            ]),
            _c("p", { staticClass: "sidecart__slider__title" }, [
              _vm._v(_vm._s(_vm._f("truncate")(_vm.item.title, 12))),
            ]),
          ]),
          _c("div", { staticClass: "sidecart__slider__content" }, [
            _c("div", { staticClass: "sidecart__slider__header" }, [
              _c("div", { staticClass: "sidecart__slider__info" }, [
                _c("div", { staticClass: "sidecart__slider__list" }, [
                  _vm.item.size
                    ? _c("p", { staticClass: "sidecart__slider__option" }, [
                        _vm._v(_vm._s(("" + _vm.item.size).toLowerCase())),
                      ])
                    : _vm._e(),
                  _vm.item.color
                    ? _c("p", { staticClass: "sidecart__slider__option" }, [
                        _vm._v(_vm._s(("" + _vm.item.color).toLowerCase())),
                      ])
                    : _vm._e(),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "sidecart__slider__details" }, [
              _c("p", { staticClass: "sidecart__slider__price" }, [
                _vm.item.compare_at_price
                  ? _c(
                      "span",
                      {
                        staticClass: "sidecart__slider__price--compare-at p-s",
                      },
                      [
                        _vm._v(
                          _vm._s(_vm._f("money")(_vm.item.compare_at_price))
                        ),
                      ]
                    )
                  : _vm._e(),
                _c("span", { staticClass: "p-m" }, [
                  _vm._v(_vm._s(_vm._f("money")(_vm.item.price))),
                ]),
              ]),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }